import React from "react";
import LinkWithIconDescription from "@qlik/qlik/src/components/Header/Sub_Menu_Components/Link_With_Icon_Description";

/**
 * SubmenuLayoutSix renders the right hand side of a main menu drop down, with
 * row of LinkWithIconDescription
 * e.g. pricing
 */
const SubmenuLayoutSix = ({ data, className = "" }) => {
    const { subItems } = data ?? {};

    return (
        <div className="submenu-level-2-wrapper xl:pt-10 xl:pb-15 w-full relative">
            <div className="-z-1 absolute max-xl:hidden bg-dropdownImage bg-contain -bottom-[324px] -right-[1145px] w-455 h-97.75" />
            <ul className="grid gap-x-15 gap-y-7.5 mt-5 grid-cols-1 lg:grid-cols-3 ">
                {subItems?.map((subItem) => (
                    <LinkWithIconDescription key={subItem.id} data={subItem} />
                ))}
            </ul>
        </div>
    );
};

export default SubmenuLayoutSix;
